import { ACTIVATE_TOOLTIP, DEACTIVATE_TOOLTIP } from "./actions/types";

const initialState = {
  activeToolTipIndex: null
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ACTIVATE_TOOLTIP:
      return {
        ...state,
        activeToolTipIndex: action.payload.activeToolTipIndex
      };
    case DEACTIVATE_TOOLTIP:
      return {
        ...state,
        activeToolTipIndex: null
      };
    default:
      return state;
  }
}

export const activateToolTip = index => dispatch => {
  dispatch({
    type: ACTIVATE_TOOLTIP,
    payload: { activeToolTipIndex: index }
  });
};

export const deactivateToolTip = () => dispatch => {
  dispatch({
    type: DEACTIVATE_TOOLTIP,
    payload: { activeToolTipIndex: null }
  });
};
